exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* 可以添加一些样式来调整图表的外观 */\n", ""]);

// exports
